import React from "react";

export const AccompanyingPersonsSummarySection = ({
  formData,
  accompanyingPersons,
  accompanyingPersonFee,
  registrationFee,
}) => {
  const allAccompanyingPersons = accompanyingPersons.map((person) => {
    const isPaid = person.paid || !!person.paymentId;
    const paidFee = formData.additionalFees?.find(
      (fee) =>
        accompanyingPersonFee &&
        fee.feeTypeId === accompanyingPersonFee.id &&
        fee.name === person.name &&
        fee.paymentId
    );
    const savedZero = formData.zeroPayments?.find(
      (zp) =>
        accompanyingPersonFee &&
        zp.feeTypeId === accompanyingPersonFee.id &&
        zp.name === person.name
    );

    return {
      name: person.name,
      paid: isPaid || !!paidFee,
      saved: !!savedZero && !isPaid && !paidFee,
      paymentId: person.paymentId || paidFee?.paymentId,
      source: paidFee ? "paid" : savedZero ? "saved" : "new",
      rate: paidFee?.rate || accompanyingPersonFee?.rate || 0,
      currency:
        paidFee?.currency ||
        accompanyingPersonFee?.currency ||
        registrationFee?.currency ||
        "INR",
    };
  });

  console.log("Accompanying Persons Display (from state):");
  console.log("  - accompanyingPersons state:", accompanyingPersons);
  console.log("  - Final list with payment status:", allAccompanyingPersons);

  if (allAccompanyingPersons.length === 0) {
    return null;
  }

  const displayRate =
    accompanyingPersonFee?.rate || allAccompanyingPersons[0]?.rate || 0;
  const displayCurrency =
    accompanyingPersonFee?.currency ||
    allAccompanyingPersons[0]?.currency ||
    registrationFee?.currency ||
    "INR";
  const currencySymbol = formData.country === "India" ? "₹" : "$";

  return (
    <div className="summary-section">
      <h4>Accompanying Persons</h4>
      {allAccompanyingPersons.map((person, index) => (
        <div className="summary-row" key={index}>
          <span className="summary-label">Person {index + 1}:</span>
          <span className="summary-value">
            {person.name}
            {person.paid && (
              <span
                style={{
                  marginLeft: "8px",
                  color: "#28a745",
                  fontSize: "12px",
                }}
              >
                ✓ Paid
              </span>
            )}
            {person.saved && !person.paid && (
              <span
                style={{
                  marginLeft: "8px",
                  color: "#0d6efd",
                  fontSize: "12px",
                }}
              >
                ✓ Saved
              </span>
            )}
          </span>
        </div>
      ))}
      {accompanyingPersonFee && (
        <>
          <div className="summary-row">
            <span className="summary-label">Fee per Person:</span>
            <span className="summary-value">
              {currencySymbol}
              {parseFloat(displayRate).toFixed(2)} ({displayCurrency})
            </span>
          </div>
          <div className="summary-row">
            <span className="summary-label">
              Subtotal ({allAccompanyingPersons.length} person
              {allAccompanyingPersons.length > 1 ? "s" : ""}):
            </span>
            <span className="summary-value" style={{ fontWeight: "bold" }}>
              {currencySymbol}
              {(
                parseFloat(displayRate) * allAccompanyingPersons.length
              ).toFixed(2)}{" "}
              ({displayCurrency})
            </span>
          </div>
        </>
      )}
    </div>
  );
};

const getFocusedSessionName = ({
  sessionId,
  paidSession,
  focusedSessions,
  zeroPayments,
}) => {
  if (paidSession?.name && typeof paidSession.name === "string") {
    return paidSession.name;
  }

  const sessionObj = focusedSessions.find((session) => session.id === sessionId);
  if (sessionObj?.value && typeof sessionObj.value === "string") {
    return sessionObj.value;
  }

  const zeroPayment = zeroPayments?.find((item) => item.feeTypeId === sessionId);
  if (zeroPayment?.name && typeof zeroPayment.name === "string") {
    return zeroPayment.name;
  }

  return `Session ${sessionId}`;
};
